import { ClipPath, Defs, G, Path, Svg } from 'react-native-svg';

import { type IconProps } from '../types';

interface IconRewardsAndOffersWithDividerProps extends IconProps {
  dividerColor?: string;
}

export const IconRewardsAndOffersWithDivider = (props: IconRewardsAndOffersWithDividerProps) => {
  const { size = 91, color, dividerColor, ...otherProps } = props;

  return (
    <Svg
      width={size}
      height={size}
      fill="none"
      color={color ?? 'black'}
      {...otherProps}
      viewBox="0 0 91 78"
      {...props}
    >
      <G clipPath="url(#clip0_22380_9322)" fillRule="evenodd" clipRule="evenodd">
        <Path
          d="M72.439 81H-1V-1h75.373l.298.327C84.194 9.805 90 23.725 90 39c0 16.286-6.6 31.032-17.268 41.707l-.293.293zM73.93 0C83.293 10.3 89 23.984 89 39c0 16.01-6.487 30.505-16.976 41H0V0h73.93z"
          fill={dividerColor ?? '#000'}
          fillOpacity={0.1}
        />
        <Path
          d="M30.787 56.34a2 2 0 01-2.128-1.552l-1.062-4.71a2 2 0 00-.935-1.283l-4.087-2.41a2 2 0 01-.82-2.517l1.91-4.411a2 2 0 00.003-1.582l-1.902-4.44a2 2 0 01.814-2.505l4.148-2.474a2 2 0 00.927-1.282l1.048-4.69a2 2 0 012.143-1.555l4.724.453a2 2 0 001.51-.489l3.627-3.186a2 2 0 012.635-.005l3.609 3.148a2 2 0 001.492.485l4.77-.425a2 2 0 012.129 1.552l1.06 4.71a2 2 0 00.936 1.282l4.087 2.41a2 2 0 01.82 2.518l-1.91 4.411a2 2 0 00-.002 1.582l1.901 4.44a2 2 0 01-.814 2.505l-4.148 2.474a2 2 0 00-.927 1.282l-1.048 4.69a2 2 0 01-2.143 1.555l-4.723-.453a2 2 0 00-1.511.489l-3.627 3.186a2 2 0 01-2.634.005l-3.61-3.148a2 2 0 00-1.492-.485l-4.77.425zM48 48.225c1 0 1.85-.35 2.55-1.05.7-.7 1.05-1.55 1.05-2.55 0-1-.35-1.85-1.05-2.55-.7-.7-1.55-1.05-2.55-1.05-1 0-1.85.35-2.55 1.05-.7.7-1.05 1.55-1.05 2.55 0 1 .35 1.85 1.05 2.55.7.7 1.55 1.05 2.55 1.05zm-12.12-.12l15.6-15.6-3.36-3.36-15.6 15.6 3.36 3.36zm.12-11.88c1 0 1.85-.35 2.55-1.05.7-.7 1.05-1.55 1.05-2.55 0-1-.35-1.85-1.05-2.55-.7-.7-1.55-1.05-2.55-1.05-1 0-1.85.35-2.55 1.05-.7.7-1.05 1.55-1.05 2.55 0 1 .35 1.85 1.05 2.55.7.7 1.55 1.05 2.55 1.05z"
          fill="#E31837"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_22380_9322">
          <Path fill="#fff" d="M0 0H91V78H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
